/**
 * Lightweight export of client-safe environment variables.
 * Values are resolved at build time by Next.js.
 */

const nodeEnv = process.env.NODE_ENV ?? 'development';

export const runtimeEnv = {
  NEXT_PUBLIC_CONVEX_URL: process.env.NEXT_PUBLIC_CONVEX_URL ?? '',
  NEXT_PUBLIC_ENABLE_IMAGE_OPT_JOBS: process.env.NEXT_PUBLIC_ENABLE_IMAGE_OPT_JOBS === 'true',
  NEXT_PUBLIC_USE_NEW_FAVICON: process.env.NEXT_PUBLIC_USE_NEW_FAVICON === 'true',
  NEXT_PUBLIC_USE_ICONIFY_LIBRARY: process.env.NEXT_PUBLIC_USE_ICONIFY_LIBRARY === 'true',
  NEXT_PUBLIC_CHRONICLES_BUCKET: process.env.NEXT_PUBLIC_CHRONICLES_BUCKET ?? '',
  NEXT_PUBLIC_CHRONICLES_PROXY_URL: process.env.NEXT_PUBLIC_CHRONICLES_PROXY_URL ?? '',
  NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN ?? '',
  DEV: nodeEnv !== 'production',
  PROD: nodeEnv === 'production',
  MODE: process.env.NEXT_PUBLIC_APP_ENV ?? nodeEnv,
} as const;

export type RuntimeEnv = typeof runtimeEnv;
